import { createSelector } from 'reselect';

const allIds = (state) => state.entities.region.allIds;
const byId = (state) => state.entities.region.byId;

export const getAllRegions = createSelector(
  [ byId, allIds ],
  (regions, ids) => {
    return ids.map(id => regions[id]);
  }
);

export const getAllRegionsWithAdminUser = createSelector(
  [getAllRegions],
  (regions) => {
    return regions.filter(region => region.adminUser);
  }
);


// WEBPACK FOOTER //
// ./src/modules/region/region.selectors.js